import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import AppShell from "../layouts/AppShell";
import { appModules } from "../components/global";
import Switch from "react-switch";
import { GET, POST, PUT, DELETE, loading, alert, DateInput } from "../components/CustomComponent";

const OvertimeModal = ({ show, onHide, editData, onSave }) => {
  const [isActive, setIsActive] = useState(true);

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
    <Modal.Header closeButton className="bg-light border-0">
      <Modal.Title className="fw-bold h5 mb-0">
        {editData ? "รายละเอียดคำขอ OT" : "ส่งคำขอทำ OT ล่วงเวลา"}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <form className="row g-3">
        <div className="col-md-12">
          <label className="form-label">ชื่อพนักงาน</label>
          <input type="text" className="form-control" defaultValue={editData?.name || ""} placeholder="ค้นหาพนักงาน..." />
        </div>
        <div className="col-md-4">
          <label className="form-label">วันที่ทำ OT</label>
          <DateInput className="form-control" defaultValue={editData?.date || ""} />
        </div>
        <div className="col-md-4">
          <label className="form-label">จำนวน (ชั่วโมง)</label>
          <input type="number" step="0.5" className="form-control" defaultValue={editData?.hours || ""} placeholder="0.0" />
        </div>
        <div className="col-md-4">
          <label className="form-label">ประเภทเรท</label>
          <select className="form-select" defaultValue={editData?.rate || ""}>
            <option value="1.5">1.5 เท่า (วันปกติ)</option>
            <option value="3.0">3.0 เท่า (วันหยุด)</option>
          </select>
        </div>
        <div className="col-12">
          <label className="form-label">รายละเอียดงานที่ทำ</label>
          <textarea className="form-control" rows="2" placeholder="ระบุขอบเขตงานที่รับผิดชอบช่วง OT..."></textarea>
        </div>
        <div className="col-12">
          <label className="form-label mb-0 pointer" htmlFor="isActiveOvertime">เปิดใช้งาน (Active)</label><br/>
          <Switch checked={isActive} onChange={setIsActive} onColor="#0c75e6" height={24} width={48} id="isActiveOvertime" />
        </div>
      </form>
    </Modal.Body>
    <Modal.Footer className="bg-light border-0">
      <button type="button" className="btn btn-secondary" onClick={onHide}>ปิด</button>
      <button type="button" className="btn btn-primary" onClick={() => onSave({ isActive })}>บันทึก/อนุมัติ</button>
    </Modal.Footer>
  </Modal>
  );
};

export default function Overtime() {
  const { title, description } = appModules["overtime"];
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [data, setData] = useState([]);

  const summaryCards = [
    { label: "ชั่วโมง OT ทั้งหมด (เดือนนี้)", value: "184.5", color: "#0c76e5" },
    { label: "รออนุมัติ (รายการ)", value: "12", color: "#e5a93e" },
    { label: "ค่าใช้จ่าย OT คาดการณ์", value: "฿ 45,200", color: "#e53e3e" },
  ];

  const handleOpenModal = (data = null) => {
    setEditData(data);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setEditData(null);
    setShowModal(false);
  };

  const GetData = async () => {
    loading(true);
    let body = {};
    let result = await GET("v1/admin/overtimes", body);
    if (result?.status) {
      setData(result.data || []);
    }
    loading(false);
  };

  useEffect(() => {
    GetData();
  }, []);

  const CreateUpdate = async (formData) => {
    if (
      await alert("", "info", "ยืนยัน", "ยืนยันการบันทึกข้อมูลหรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      let uid = formData?.uid || editData?.uid;
      let body = { ...formData };

      let result = !uid
        ? await POST("v1/admin/overtimes", body)
        : await PUT("v1/admin/overtimes/" + uid, body);
        
      if (result?.status === true) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        GetData();
        handleCloseModal();
      } else {
        alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
      }
      loading(false);
    }
  };

  const DeleteData = async (id) => {
    if (
      await alert("", "warning", "ลบรายการ", "ต้องการลบรายการนี้ใช่หรือไม่?", "ยืนยัน", "ยกเลิก")
    ) {
      loading(true);
      let result = await DELETE("v1/admin/overtimes/" + id, null);
      if (result?.status) {
        alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
        GetData();
      }
      loading(false);
    }
  };

  return (
    <AppShell title={title} description={description}>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
        <div className="d-flex gap-2 filters-mobile-stack">
          <select className="form-select" style={{ width: '180px', borderRadius: '12px' }}>
            <option>รายการทั้งหมด</option>
            <option>เฉพาะรออนุมัติ</option>
          </select>
        </div>
        <button onClick={() => handleOpenModal()} className="btn btn-primary px-4">
          ส่งคำขอ OT
        </button>
      </div>

      <div className="row g-3 mb-4">
        {summaryCards.map((item) => (
          <div key={item.label} className="col-12 col-md-4">
            <div
              className="h-100 rounded-4 p-4 d-flex flex-column justify-content-center"
              style={{
                background: "linear-gradient(180deg, #ffffff 0%, #f2f9ff 100%)",
                border: "1px solid rgba(18, 125, 255, 0.10)",
                boxShadow: "0 14px 28px rgba(12, 118, 229, 0.06)",
              }}
            >
              <p className="small text-uppercase text-secondary mb-1">{item.label}</p>
              <h2 className="h3 mb-0 fw-bold" style={{ color: item.color }}>{item.value}</h2>
            </div>
          </div>
        ))}
      </div>

      <div
        className="rounded-4 p-3 bg-white"
        style={{
          border: "1px solid rgba(18, 125, 255, 0.10)",
          boxShadow: "0 4px 12px rgba(12, 118, 229, 0.04)",
        }}
      >
        <h5 className="mb-4 fw-semibold text-dark">รายการคำขอ OT ล่วงเวลา</h5>
        <div className="table-responsive table-mobile-cards">
          <table className="table table-hover align-middle">
            <thead className="table-light">
              <tr>
                <th className="text-secondary fw-medium rounded-start">วันที่ทำ OT</th>
                <th className="text-secondary fw-medium">ชื่อพนักงาน</th>
                <th className="text-secondary fw-medium text-center">ประเภทเรท</th>
                <th className="text-secondary fw-medium text-center">จำนวน (ชม.)</th>
                <th className="text-secondary fw-medium text-center rounded-end">อนุมัติ</th>
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3].map((i) => (
                <tr key={i}>
                  <td data-label="วันที่ทำ OT">23 มี.ค. 2026</td>
                  <td data-label="ชื่อพนักงาน"><div className="fw-medium">พนักงาน ทดสอบ {i}</div></td>
                  <td data-label="ประเภทเรท" className="text-center">1.5x (วันทำงาน)</td>
                  <td data-label="จำนวน (ชม.)" className="text-center fw-bold">3.0</td>
                  <td data-label="อนุมัติ" className="text-center">
                    <button onClick={() => handleOpenModal({ name: `พนักงาน ทดสอบ ${i}`, date: "2026-03-23", hours: 3.0, rate: "1.5" })} className="btn btn-sm btn-outline-primary rounded-3 me-2" title="จัดการ"><i className="fa-solid fa-pen" /></button>
                    <button className="btn btn-sm btn-success rounded-3 me-2">ใช่</button>
                    <button className="btn btn-sm btn-outline-danger rounded-3">ไม่</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <OvertimeModal show={showModal} onHide={handleCloseModal} editData={editData} onSave={CreateUpdate} />
    </AppShell>
  );
}